<template>
  <TableLayout :permissions="['business:membercoupon:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="主键" prop="id">
        <el-input v-model="searchForm.id" placeholder="请输入主键" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建人编码" prop="creator">
        <el-input v-model="searchForm.creator" placeholder="请输入创建人编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="searchForm.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
      </el-form-item>
      <el-form-item label="更新人编码" prop="editor">
        <el-input v-model="searchForm.editor" placeholder="请输入更新人编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="更新时间" prop="editDate">
        <el-date-picker v-model="searchForm.editDate" value-format="yyyy-MM-dd" placeholder="请输入更新时间" @change="search"/>
      </el-form-item>
      <el-form-item label="是否删除0否 1是" prop="isdeleted">
        <el-input v-model="searchForm.isdeleted" placeholder="请输入是否删除0否 1是" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="searchForm.remark" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="用户编码（关联member表）" prop="memberId">
        <el-input v-model="searchForm.memberId" placeholder="请输入用户编码（关联member表）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="商家编码（关联shop表）" prop="shopId">
        <el-input v-model="searchForm.shopId" placeholder="请输入商家编码（关联shop表）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="类型0商家优惠券 1平台优惠券 " prop="type">
        <el-input v-model="searchForm.type" placeholder="请输入类型0商家优惠券 1平台优惠券 " @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="满额（元）" prop="limitPrice">
        <el-input v-model="searchForm.limitPrice" placeholder="请输入满额（元）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="优惠金额（元）" prop="price">
        <el-input v-model="searchForm.price" placeholder="请输入优惠金额（元）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="开始时间" prop="startDate">
        <el-date-picker v-model="searchForm.startDate" value-format="yyyy-MM-dd" placeholder="请输入开始时间" @change="search"/>
      </el-form-item>
      <el-form-item label="结束时间" prop="endDate">
        <el-date-picker v-model="searchForm.endDate" value-format="yyyy-MM-dd" placeholder="请输入结束时间" @change="search"/>
      </el-form-item>
      <el-form-item label="领取方式 0领取 1兑换" prop="getMethod">
        <el-input v-model="searchForm.getMethod" placeholder="请输入领取方式 0领取 1兑换" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="兑换所需咖豆金额" prop="integral">
        <el-input v-model="searchForm.integral" placeholder="请输入兑换所需咖豆金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="状态 0未使用 1已使用" prop="status">
        <el-input v-model="searchForm.status" placeholder="请输入状态 0未使用 1已使用" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="说明" prop="info">
        <el-input v-model="searchForm.info" placeholder="请输入说明" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="使用时间" prop="useDate">
        <el-date-picker v-model="searchForm.useDate" value-format="yyyy-MM-dd" placeholder="请输入使用时间" @change="search"/>
      </el-form-item>
      <el-form-item label="使用积分奖励数量" prop="backIntegral">
        <el-input v-model="searchForm.backIntegral" placeholder="请输入使用积分奖励数量" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="id" label="主键" min-width="100px"></el-table-column>
        <el-table-column prop="creator" label="创建人编码" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="更新人编码" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="更新时间" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否删除0否 1是" min-width="100px"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="memberId" label="用户编码（关联member表）" min-width="100px"></el-table-column>
        <el-table-column prop="shopId" label="商家编码（关联shop表）" min-width="100px"></el-table-column>
        <el-table-column prop="type" label="类型0商家优惠券 1平台优惠券 " min-width="100px"></el-table-column>
        <el-table-column prop="limitPrice" label="满额（元）" min-width="100px"></el-table-column>
        <el-table-column prop="price" label="优惠金额（元）" min-width="100px"></el-table-column>
        <el-table-column prop="startDate" label="开始时间" min-width="100px"></el-table-column>
        <el-table-column prop="endDate" label="结束时间" min-width="100px"></el-table-column>
        <el-table-column prop="getMethod" label="领取方式 0领取 1兑换" min-width="100px"></el-table-column>
        <el-table-column prop="integral" label="兑换所需咖豆金额" min-width="100px"></el-table-column>
        <el-table-column prop="status" label="状态 0未使用 1已使用" min-width="100px"></el-table-column>
        <el-table-column prop="info" label="说明" min-width="100px"></el-table-column>
        <el-table-column prop="useDate" label="使用时间" min-width="100px"></el-table-column>
        <el-table-column prop="backIntegral" label="使用积分奖励数量" min-width="100px"></el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
export default {
  name: 'MemberCoupon',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        remark: '',
        memberId: '',
        shopId: '',
        type: '',
        limitPrice: '',
        price: '',
        startDate: '',
        endDate: '',
        getMethod: '',
        integral: '',
        status: '',
        info: '',
        useDate: '',
        backIntegral: ''
      }
    }
  },
  created () {
    this.config({
      module: '用户优惠券关联表',
      api: '/business/memberCoupon',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
